import { Route, Routes } from "react-router-dom"

import { BatteryOnlyProposalShell } from "./BatteryOnlyProposalShell"
import { BatteryContractDrawer } from "./contract/BatteryContractDrawer"
import { BatteryFinancingStatusDrawer } from "./financing-status/BatteryFinancingStatusDrawer"
import { BatterySetupDrawer } from "./setup/BatterySetupDrawer"
import { BatteryShareDrawer } from "./share/BatteryShareDrawer"

export const BatteryOnlyProposalRoutes = (): JSX.Element => (
  <Routes>
    <Route
      path="battery-proposal/:proposalId"
      element={<BatteryOnlyProposalShell />}
    >
      {/* Every child renders through the shell's Outlet, and the shell owns the
          read-only gate: it needs the proposal read contract to know whether
          this actor may edit, which is not readable this far up the tree. So
          these routes are registered unconditionally and the shell redirects a
          read-only actor back to the proposal before any of them renders.
          Status drawers stay available — their own mutations are server-gated. */}
      <Route path="contract" element={<BatteryContractDrawer />} />
      <Route
        path="financing-status"
        element={<BatteryFinancingStatusDrawer />}
      />
      <Route path="share" element={<BatteryShareDrawer />} />
      <Route path="setup" element={null} />
      <Route path="setup/:groupId" element={null} />
      <Route path="equipment" element={<BatterySetupDrawer />} />
      <Route path="finance-product" element={<BatterySetupDrawer />} />
      <Route path="adders" element={<BatterySetupDrawer />} />
      <Route path="warranty" element={<BatterySetupDrawer />} />
      <Route path="system-pricing" element={<BatterySetupDrawer />} />
      <Route path="incentives" element={<BatterySetupDrawer />} />
      <Route path="vpp-programs" element={<BatterySetupDrawer />} />
      <Route path="site" element={<BatterySetupDrawer />} />
      <Route path="utility" element={<BatterySetupDrawer />} />
      <Route path="greenbutton" element={<BatterySetupDrawer />} />
      <Route path="arbitrage" element={<BatterySetupDrawer />} />
    </Route>
  </Routes>
)
